<template>
  <div
    class="new_center_container"
    :class="{'other_container_height': tabActiveId === '0' || tabActiveId === '1'}"
  >
    <div class="header">
      <p class="title download-cn">下载中心</p>
      <!-- <p class="title download-en">DOWNLOAD</p> -->
      <div class="tabs">
        <el-tabs v-model="tabActiveId">
          <el-tab-pane v-for="item in tabs" :key="item.v" :label="item.k" :name="item.v" />
        </el-tabs>
      </div>
      <div class="download-list-container">
        <ul
          class="list"
          :class="{'more_list': tabActiveId === '0' || tabActiveId === '1'}"
        >
          <li
          :class="{blackGray: item.key && item.key === 'blackboard' && tabActiveId === '1'}"
          v-for="(item, index) in data[+tabActiveId].list" class="item" :key="index">
            <img :src="item.pic" alt class="logo" />
            <p class="item-title">{{ item.title }}</p>
            <p v-if="tabActiveId === '2' && item.title ==='超级课件授课端'" class="redDes">{{ item.des }}</p>
            <p v-else :class="item.key === 'superCoursewareLink' ?  'subtitle super-mb' : 'subtitle mb'">{{ item.des }}</p>
            <div class="qr-box" v-if="item.type === 1">
              <div v-for="(v, i) in item.code" :key="i">
                <img :src="v.url" alt class="code" />
                <p class="des">{{ v.platform }}</p>
              </div>
            </div>
            <div class="download-box" v-else>
              <a
                class="download-btn"
                v-for="(v, i) in item.code"
                :key="i"
                :href="v.needLoad ? urlFormatter(v.needLoad) : v.url"
                target="_blank"
              >
                <template v-if="v.platformId !== 9">
                  <img
                    src="../../../public/img/mac_icon.png"
                    v-if="v.platformId ===4"
                    class="mac-icon"
                    alt
                  />
                  <img src="../../../public/img/win_icon.png" v-else class="win-icon" alt />
                  {{ v.platform }}
                </template>
                <template v-else>
                  {{ v.platform }}
                </template>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { list } from './assets/data'
import BackTop from '@/components/backTop/index'
/** 直播云客户端各平台 cl_type */
const futureCloudCLType = {
  Windows_stu: 1,
  Windows_teacher: 6,
  Mac_stu: 2,
  Mac_teacher: 7,
  iPhone_stu: 4,
  iPhone_teacher: 8,
  Android_stu: 5,
  Android_teacher: 9,
  iPad_stu: 3,
  iPad_teacher: 10
}

export default {
  components: { BackTop },
  data () {
    return {
      data: list,
      key: 'value',
      classSystemLink: '#',
      videoLink: '#',
      chromeLink: '#',
      AILink: '#',
      superCoursewareLink: '#',
      aiBoardLink: '#',
      macBoardLink: '#',
      magicBlackboardLink: '#',
      macBlackboardLink: '#',
      randomNum: 0,
      tabActiveId: this.$route.query.roomTabIndex ? this.$route.query.roomTabIndex : '0',
      tabs: [
        {
          k: '学生端',
          v: '0'
        },
        {
          k: '机构老师端',
          v: '1'
        },
        {
          k: '机构教室端',
          v: '2'
        }
      ],
      liveCloudStudentPathForPC: '', // 直播云·学生PC端
      liveCloudTeacherPathForPC: '', // 直播云·老师PC端
      liveCloudStudentPathForMac: '', // 学生Mac端
      liveCloudTeacherPathForMac: '', // 老师Mac端
      // 注释掉的励步客户端下载地址 是接受励步之后  思思找到的地址
      // libuCloudPathForMac: 'https://haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/libu/Leapflow-Classroom-darwin-x64.zip',
      // libuCloudPath: 'https://haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/libu/Leapflow-Classroom-win32.zip'
      libuCloudPathForMac: 'https://haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/libu/Leapflow-Classroom-darwin-x64-20221101.zip',
      libuCloudPath: 'https://haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/libu/Leapflow-Classroom-win32-ia32-20221101.zip'
    }
  },
  created () {
    this.randomNum = Math.random() * 1000
    this.getclassSystemLink()
    this.getAiLink()
    this.getSuperCoursewareLink()
    this.getvideoLink()
    this.getchromeLink()
    this.getBoardLink()
    this.getMacPath()
    this.getMagicBoardLink()
    this.getLejialeLink()
  },
  methods: {
    urlFormatter (k) {
      return this[k]
    },
    // 获取直播云mac版本客户端地址path
    getMacPath () {
      let baseUrl = process.env.VUE_APP_ENV !== 'production' ? 'https://test-openapi.weclassroom.com' : 'https://openapi.weclassroom.com'
      this.$axios.post(`${baseUrl}/official/homepage/download/index`, {}).then((res) => {
        console.log('直播云地址', res)
        if (res.status === 200) {
          if (res.data && res.data.status === 1) {
            let data = res.data.data.list
            data.forEach((item) => {
              if (item.cl_type === futureCloudCLType.Mac_stu) {
                this.liveCloudStudentPathForMac = item.url
              } else if (item.cl_type === futureCloudCLType.Mac_teacher) {
                this.liveCloudTeacherPathForMac = item.url
              } else if (item.cl_type === futureCloudCLType.Windows_stu) {
                this.liveCloudStudentPathForPC = item.url
              } else if (item.cl_type === futureCloudCLType.Windows_teacher) {
                this.liveCloudTeacherPathForPC = item.url
              }
            })
          }
        }
      })
    },
    getclassSystemLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/student/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.classSystemLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/student/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAiLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/AI/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.AILink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/AI/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSuperCoursewareLink () {
      let $this = this
      $this.superCoursewareLink = '//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/super-courseware/production/超级课件授课端-1.2.0.exe'
    },
    getvideoLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/vdyoo/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.videoLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/vdyoo/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getchromeLink () {
      let $this = this
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/chrome/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.chromeLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/chrome/${response.data.path}`
        })
        .catch(error => {
          console.log(error)
        })
    },
    getBoardLink () {
      let $this = this
      let agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0 || isMac) {
        this.$axios
          .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard64/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.aiBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard64/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$axios
          .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.aiBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      }
      this.$axios
        .get(`//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard-mac/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.macBoardLink = `//haoweilai-tob-pro-video.oss-cn-beijing.aliyuncs.com/interaction-client/blackboard-mac/${response.data.path}`
          console.log($this.macBoardLink)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMagicBoardLink () {
      let $this = this
      let agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0 || isMac) {
        this.$axios
          .get(`//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/win64/production/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.magicBlackboardLink = `//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/win64/production/${response.data.version}/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$axios
          .get(`//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/win64/production/latest.json?time=${Date.now()}`)
          .then(response => {
            $this.magicBlackboardLink = `//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/win64/production/${response.data.version}/${response.data.path}`
          })
          .catch(error => {
            console.log(error)
          })
      }
      this.$axios
        .get(`//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/darwin/production/latest.json?time=${Date.now()}`)
        .then(response => {
          $this.macBlackboardLink = `//ms-public.oss-cn-zhangjiakou.aliyuncs.com/pubilish-test/cactus-blackboard-02/darwin/production/${response.data.version}/${response.data.path}`
          console.log($this.macBlackboardLink)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getLejialeLink () {
      const envPath = process.env.VUE_APP_ENV === 'production' ? 'production' : 'staging'
      let $this = this
      this.$axios
        .get(`https://lejiale-static.oss-cn-beijing.aliyuncs.com/lejiale-classroom/latest/${envPath}/latest.json?time=${Date.now()}`)
        .then(response => {
          const win64 = response.data.win64
          $this.lejialeLinkForPC = win64.baseUrl + win64.path
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  computed: {
    name () {
      return this.key
    }
  }
}
</script>

<style scoped lang="scss">
.new_center_container {
  margin: 80px auto 0 auto;
  width: 1280px;
  // height: 660px;
  height: 570px;
  ul {
    padding-left: 0;
  }
  .header {
    position: relative;
    height: 420px;
    background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/img/download_bg.png')
      no-repeat center center;
    background-size: 1280px 420px;
    .title {
      position: absolute;
      left: 80px;
      &.download-cn {
        top: 40px;
        font-size: 40px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 56px;
      }
      &.download-en {
        top: 76px;
        font-size: 56px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 78px;
        opacity: 0.1;
      }
    }
    .tabs {
      position: absolute;
      // top: 160px;
      top: 120px;
      left: 70px;
      width: 1106px;
      ::v-deep .el-tabs__item {
        margin-bottom: 20px;
        padding: 0 30px;
        height: 30px;
        font-size: 22px;
        line-height: 30px;
        color: rgba(255, 255, 255, 0.5);
      }
      ::v-deep .is-active {
        color: #ffffff;
      }
      ::v-deep .el-tabs__active-bar {
        background-color: #ffffff;
        height: 4px;
        border-radius: 2px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 4px;
        background: linear-gradient(
          270deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 49%,
          rgba(255, 255, 255, 0) 100%
        );
        opacity: 0.4;
      }
      ::v-deep .el-tabs__nav {
        margin-left: 320px;
      }
    }
    .download-list-container {
      position: absolute;
      // top: 210px;
      top: 180px;
      width: 100%;
      img {
        width: 80px;
        height: 80px;
        &.logo {
          border-radius: 14px;
        }
      }
      .list {
        justify-content: center;
        display: flex;
        .item {
          // margin: 40px 8px 0;
          margin: 20px 8px 0;
          width: 264px;
          // height: 366px;
          height: 330px;
          // padding: 40px 38px 37px;
          padding: 20px 38px 20px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0 0 10px 0 rgba(81, 85, 105, 0.22);
          border-radius: 10px;
        }
        .blackGray {
          .subtitle{
            margin-bottom: 10px;
          }
        }
        .logo {
          margin: 0 auto;
        }
        .item-title {
          margin: 20px 0 8px;
          font-weight: 600;
          color: rgba(40, 40, 40, 1);
          line-height: 22px;
        }
        .subtitle {
          font-size: 14px;
          font-weight: 300;
          color: rgba(40, 40, 40, 1);
          line-height: 20px;
        }
        .redDes {
          font-size: 14px;
          font-weight: 300;
          color: rgba(240, 93, 78, 1);
          line-height: 20px;
          margin-bottom: 30px;
        }
        .mb{
          margin-bottom: 30px;
        }
        .super-mb{
          margin-bottom: 10px;
        }
        .qr-box {
          text-align: center;
          display: flex;
          justify-content: center;
          img {
            margin: 0 15px;
          }
          .des {
            margin-top: 9px;
            font-size: 14px;
            font-weight: 300;
            color: rgba(40, 40, 40, 1);
            line-height: 20px;
          }
        }
        .download-box {
          padding-top: 10px;
          .download-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 188px;
            height: 36px;
            font-size: 14px;
            color: rgba(248, 248, 248, 1);
            line-height: 36px;
            background: rgba(251, 89, 74, 1);
            border-radius: 5px;
            text-align: center;
            cursor: pointer;
            &:first-child {
              margin-bottom: 10px;
            }
            .mac-icon {
              width: 20px;
              height: 20px;
              margin-right: 4px;
            }
            .win-icon {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
      }

      .more_list {
        padding-left: 80px;
        justify-content: left;
        flex-wrap: wrap;
      }
    }
  }
}
.other_container_height {
  // height: 1060px;
  height: 920px;
}
</style>
